<button class="linklike" id="back">&larr; Retour</button>
<div class="seriesHeader">
  <img class="seriesPoster" id="seriesPoster" alt="" loading="lazy" onerror="this.classList.add('noImage')" />
  <div class="seriesInfo">
    <h1 id="seriesTitle"></h1>
    <p class="seriesOverview hide" id="seriesOverview"></p>
    <div class="seriesActions">
      <button id="launchSeriesBtn">Lancer toute la série</button>
      <button class="secondaryBtn" id="createStaticBtn">Créer une lounge party</button>
      <a class="linklike" id="embyLink" target="_blank" rel="noopener">Voir sur Emby</a>
    </div>
  </div>
</div>
<nav id="seasonTabs" class="tabs"></nav>
<div class="seasonActions hide" id="seasonActions">
  <button id="launchSeasonBtn">Lancer cette saison</button>
  <button class="secondaryBtn" id="createSeasonStaticBtn">Lounge party de cette saison</button>
</div>
<div id="episodeList" class="episodeList"><p class="hint">Chargement...</p></div>
